import { ADD_PRODUCT, DECREMENT_STOCK, INCREMENT_STOCK } from "./actionTypes";

const initialState = {
    products: []
}

const productReducer = (state=initialState, action) => {

    
    switch (action.type) {
        case ADD_PRODUCT:
            return {
                ...state,
                products: [...state.products, action.payload]
            }
        
        case DECREMENT_STOCK:
                return {
                    ...state,
                    products: state.products.map((product) => {
                        if(product.id === action.payload.id){
                            product.stock = product.stock - 1;
                            return product
                        }
                        return product
                    })
                }
        case INCREMENT_STOCK:
                return {
                    ...state,
                    products: state.products.map((product) => {
                        if(product.id === action.payload.productId){
                            product.stock = product.stock + action.payload.amount;
                            return product
                        }
                        return product
                    })
                }
    
        default:
            return state
    }
}

export default productReducer;